import {
    extend
} from 'vee-validate'
import {
    alpha,
    alpha_num,
    email,
    required,
    numeric,
    confirmed
} from 'vee-validate/dist/rules'

const ValidateField = {
    created() {
        extend('alpha', {
            ...alpha,
            message: "Deve conter apenas letras"
        })

        extend('required', {
            ...required,
            message: "Esse campo é obrigatório"
        })

        extend('alpha_num', {
            ...alpha_num,
            message: "Deve conter números e/ou letras"
        })

        extend('email', {
            ...email,
            message: "Digite um e-mail válido"
        })

        extend('numeric', {
            ...numeric,
            message: "Apenas números"
        })

        extend('confirmed', {
            ...confirmed,
            message: "Os campos devem ser iguais"
        })
        extend('cpf', strCPF => {
            let soma, resto, i;
            soma = 0;

            strCPF = strCPF.replace(/[^0-9]/g, '');

            if (strCPF == "00000000000" || strCPF == "11111111111") return "CPF Incorreto";

            for (i = 1; i <= 9; i++) {
                soma = soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
            }
            resto = (soma * 10) % 11;

            if ((resto == 10) || (resto == 11)) {
                resto = 0;
            }
            if (resto != parseInt(strCPF.substring(9, 10))) {
                return "CPF Incorreto";
            }

            soma = 0;
            for (i = 1; i <= 10; i++) {
                soma = soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
            }
            resto = (soma * 10) % 11;

            if ((resto == 10) || (resto == 11)) {
                resto = 0;
            }
            if (resto != parseInt(strCPF.substring(10, 11))) {
                return "CPF Incorreto";
            }
            return true;
        })
    }
}

export default ValidateField